import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import IikoSetupModal from './IikoSetupModal';

const STEPS = [
  { key: 'iiko_connected', label: 'Подключите iiko', action: 'iiko' },
  { key: 'employees_added', label: 'Добавьте сотрудников', to: '/employees' },
  { key: 'plan_active', label: 'Оформите тариф', to: '/billing' },
];

const OnboardingBanner = ({ user }) => {
  const { organization, checkAuth } = useAuth();
  const onboarding = organization?.onboarding;
  const [showIikoSetup, setShowIikoSetup] = useState(false);

  if (user?.role !== 'admin' || !onboarding) return null;

  const done = STEPS.filter((s) => onboarding[s.key]).length;
  if (done === STEPS.length) return null;

  return (
    <div className="ui-banner">
      <div className="ui-banner-head">
        <h3>Первые шаги</h3>
        <span className="ui-dim">{done} из {STEPS.length}</span>
      </div>
      <div className="ui-progress">
        <span style={{ width: `${(done / STEPS.length) * 100}%` }} />
      </div>
      <ul className="ui-banner-steps">
        {STEPS.map((s) => {
          const isDone = onboarding[s.key];
          const content = <>{isDone ? '✓' : '○'} {s.label}</>;
          if (isDone) {
            return <li key={s.key} className="done">{content}</li>;
          }
          if (s.action === 'iiko') {
            return (
              <li key={s.key}>
                <button type="button" className="ui-banner-step-btn" onClick={() => setShowIikoSetup(true)}>
                  {content}
                </button>
              </li>
            );
          }
          return (
            <li key={s.key}>
              <Link to={s.to} className="ui-banner-step-btn">{content}</Link>
            </li>
          );
        })}
      </ul>

      {showIikoSetup && (
        <IikoSetupModal
          onClose={() => setShowIikoSetup(false)}
          onConnected={() => { setShowIikoSetup(false); checkAuth(); }}
        />
      )}
    </div>
  );
};

export default OnboardingBanner;
